module.exports = __webpack_public_path__ + "bf611b73.svg";